@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.config

class OrderingIncentiveConfigDto (
    val maxRidePrice: Double?,
    val minRidePrice: Double?,
    val passengerMessage: String?,
    val isEnabled: Boolean
)